import './GoBackButton.scss';
import React from 'react';
import { useNavigate } from 'react-router';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import arrowIcon from '@icons/arrow.svg';

type GoBackButtonProps = {
    className?: string;
    label?: string;
    onClick?: () => void;
};

const GoBackButton = ({ className, label, onClick }: GoBackButtonProps) => {
    const navigate = useNavigate();
    const { t } = useTranslation();

    const goBack = () => {
        if (onClick) {
            onClick();
        } else {
            navigate(-1);
        }
    };

    let text = '';

    const goBackClasses = classnames('b-go-back', className, {
        'is-hidden': window.history.length <= 1
    });

    if (typeof label !== 'undefined') {
        text = label;
    } else {
        text = t('go_back');
    }

    return (
        <div
            aria-label={text}
            role="button"
            tabIndex={0}
            onClick={goBack}
            className={goBackClasses}
            data-testid='go-back-button'
        >
            <img src={arrowIcon} className="arrow" />
            <div className="text">{text}</div>
        </div>
    );
};

export default GoBackButton;
